export enum Status {
    New = 11,
    InProgress = 12,
    Closed = 13,
    OnHold = 47
}


// WEBPACK FOOTER //
// ./src/app/customerservice/enums/ticket-status.enum.ts